export interface CreateCheckoutSessionRequest {
  successUrl: string;
  cancelUrl: string;
}

export interface StripeCheckoutSession {
  sessionId: string;
  url: string;
  amountInCents: number;
  amount: number;
  currency: string;
}
